var containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
};
var fieldsetStyle = {
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  margin: '0 12px',
  gap: '8px'
};
var orderTotals = {
  background: '#eae8e6',
  display: 'flex',
  flexDirection: 'column',
  padding: '12px',
  gap: '4px'
};
var orderTotalsContent = {
  display: 'flex',
  justifyContent: 'space-between'
};
var labelStyle = {
  background: '#eae8e6',
  borderRadius: '0 0 8px 0',
  fontSize: '12px',
  left: '0',
  padding: '0 8px 4px',
  position: 'absolute',
  top: '0'
};
var messageStyle = {
  alignItems: 'center',
  background: 'rgb(255, 249, 236)',
  borderLeftWidth: '4px',
  borderLeftStyle: 'solid',
  borderLeftColor: 'rgb(255, 176, 23)',
  padding: '12px',
  width: '100%'
};
var radioLabel = {
  alignItems: 'center',
  display: 'flex',
  gap: '4px'
};
var wrapperStyle = {
  background: '#f3f2f1',
  border: '4px solid #eae8e6',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '36px 0 0',
  position: 'relative'
};
export { containerStyle, fieldsetStyle, labelStyle, messageStyle, orderTotals, orderTotalsContent, radioLabel, wrapperStyle };